import * as React from 'react';
import { styled } from '@mui/system';

const CustomMainLogo = styled('h2')(({ theme }: any) => ({
  fontFamily: "'Lobster', cursive",
  fontWeight: 500,
  textAlign: 'center',
  color: theme.palette.text.primary,
  fontSize: '3.5em',
  margin: '.3em 0',
  lineHeight: 1,
  [theme.breakpoints.down('sm')]: {
    lineHeight: 1.2,
    margin: 0,
  },
}));

const Colored = styled('span')(({ theme }: any) => ({
  color: (theme.palette as any).blue?.main || theme.palette.primary.main,
}));

const MainLogo: React.FC = () => (
  <div>
    <CustomMainLogo aria-label="The Music School">
      <Colored>T</Colored>he <Colored>M</Colored>usic <Colored>S</Colored>chool
    </CustomMainLogo>
  </div>
);

export default MainLogo;
